// @ts-nocheck

import { renderToString } from 'react-dom/server';
import React from 'react';
import TotalMonthlyPriceBadge from 'app/shared/modules/TotalMonthlyPrice/TotalMonthlyPriceBadge';
import { shouldShowTotalMonthlyPriceBadge } from 'app/shared/utils/totalMonthlyPriceUtils';
import { listingUtils_bathSqFtRange, listingUtils_bedRange } from 'app/shared/utils/listingUtils';

import noPhoto from 'images/noPhoto.png';
import { getDotIconSize } from './dotIconSize';

const controller = {
  getDotMarkerIcon({ marker, isMobile, zoom }) {
    return {
      anchor: { x: 4, y: 2 },
      url: marker,
      scaledSize: getDotIconSize({ isMobile, zoom }),
    };
  },

  listingInfoWindowContent(listing = {}, googleMapsKey) {
    const hideStreet = listing.address && listing.address.hideStreet;
    const {
      minBeds = 0,
      maxBeds = 0,
      minBaths = 0,
      maxBaths = 0,
      minSqft = 0,
      maxSqft = 0,
    } = listing.listingMinMaxPriceBeds || {};

    const priceDisplay =
      listing.listingMinMaxPriceBeds.priceDisplay === 'Call'
        ? 'Call for price'
        : listing.listingMinMaxPriceBeds.priceDisplay;

    // Beds/baths/sqft — same logic as HdpSummaryDetails
    const rawBedText =
      listing.listingType === 'room'
        ? 'Room for rent'
        : listing.listingType === 'land'
          ? null
          : listingUtils_bedRange(minBeds, maxBeds);
    const bathText = listing.listingType === 'land' ? null : listingUtils_bathSqFtRange(minBaths, maxBaths);
    const sqftText = listingUtils_bathSqFtRange(minSqft, maxSqft);
    const showSqft = (Boolean(minSqft) || Boolean(maxSqft)) && !String(sqftText).includes('-');

    // Build styled detail items: bold dark value + gray label, matching HdpSummaryDetails
    const v = (text) => `<span class="map-popup-detail-value">${text}</span>`;
    const l = (text) => `<span class="map-popup-detail-label">${text}</span>`;

    const detailItems = [
      rawBedText === 'Studio'
        ? `${v('Studio')}`
        : rawBedText === 'Room for rent'
          ? `${v('Room for rent')}`
          : rawBedText
            ? `${v(rawBedText)} ${l(Number(rawBedText) === 1 ? 'Bed' : 'Beds')}`
            : null,
      bathText ? `${v(bathText)} ${l(Number(bathText) === 1 ? 'Bath' : 'Baths')}` : null,
      showSqft ? `${v(sqftText)} ${l('Sqft')}` : null,
    ].filter(Boolean);

    const detailsHtml = detailItems
      .map(
        (item, i) =>
          `<span class="map-popup-detail-item">${item}${i < detailItems.length - 1 ? '<span class="map-popup-detail-sep"> · </span>' : ''}</span>`,
      )
      .join('');

    // Generate TotalMonthlyPriceBadge if conditions are met
    let badgeHtml = '';
    if (shouldShowTotalMonthlyPriceBadge(listing)) {
      try {
        badgeHtml = renderToString(
          React.createElement(TotalMonthlyPriceBadge, {
            listing,
            size: 'sm',
            disableTooltip: true,
          }),
        );
      } catch (error) {
        console.warn('Failed to render TotalMonthlyPriceBadge in map popup:', error);
      }
    }

    const hasRealPhoto = (listing.photoCount ?? 0) > 0;
    const photoUrl = hasRealPhoto ? listing.medPhotoUrls?.[0] || listing.medPhotoUrl : null;
    const hasGeo = listing.geo?.lat != null && listing.geo?.lon != null;
    const streetViewUrl =
      !photoUrl && hasGeo && googleMapsKey
        ? `https://maps.googleapis.com/maps/api/streetview?size=640x480&location=${listing.geo.lat},${listing.geo.lon}&key=${googleMapsKey}`
        : null;
    const imgSrc = photoUrl || streetViewUrl || noPhoto;

    return `
      <div class="map-popup-content">
        <img class="map-popup-photo" src="${imgSrc}" alt="" aria-hidden="true" onerror="this.onerror=null;this.src='${noPhoto}';" style="width:100%;height:140px;object-fit:cover;display:block;flex-shrink:0;" />
        <div class="map-popup-text">
        <div class="map-popup-info-block">
          <div class="map-popup-price-row">
            <span class="map-popup-price">${priceDisplay}</span>
            ${badgeHtml ? `<span class="map-popup-badge">${badgeHtml}</span>` : ''}
          </div>
          ${detailsHtml ? `<div class="map-popup-details">${detailsHtml}</div>` : ''}
        </div>
          <div class="map-popup-address-block">
            <div class="map-popup-address">${hideStreet ? '(Undisclosed Address)' : listing.displayName}</div>
            <div class="map-popup-address">${listing.address?.city || ''}, ${listing.address?.state || ''} ${listing.address?.zip || ''}</div>
          </div>
        </div>
      </div>
    `;
  },
};

export default controller;
